module.exports = __webpack_public_path__ + "media/images/teaching-bg6c-1f2a2ea9cab0d6640dcf59d32ed4b421.jpeg";